import { render, staticRenderFns } from "./ReturnedOrderList.vue?vue&type=template&id=0005844e"
import script from "./ReturnedOrderList.js?vue&type=script&lang=js&external"
export * from "./ReturnedOrderList.js?vue&type=script&lang=js&external"
import style0 from "./ReturnedOrderList.vue?vue&type=style&index=0&id=0005844e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports